import { render, staticRenderFns } from "./ts_assign_worker.vue?vue&type=template&id=9c0212c2"
import script from "./ts_assign_worker.vue?vue&type=script&lang=js"
export * from "./ts_assign_worker.vue?vue&type=script&lang=js"
import style0 from "./ts_assign_worker.vue?vue&type=style&index=0&id=9c0212c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports